import { render, staticRenderFns } from "./CreatePurchaseOrder.vue?vue&type=template&id=10f8ed60&scoped=true&"
import script from "./CreatePurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./CreatePurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreatePurchaseOrder.vue?vue&type=style&index=0&id=10f8ed60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f8ed60",
  null
  
)

export default component.exports